import React, {useCallback, useEffect, useState} from 'react'
import {
  CButton,
  CFormGroup,
  CModal,
  CModalBody,
} from "@coreui/react";
import { useTranslation } from "react-i18next";
import {useForm} from "react-hook-form";
import MFAService from "../../services/MFAService";
import Loading from "../loading/Loading";
import QRCode from "react-qr-code";

const MultiFactorRegistration = (props) => {
  const { i18n } = useTranslation();
  const [qrCode, setQrCode] = useState("");
  const [loaded, setLoaded] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm()

  const onSubmit = (data) => {
    props.onSubmit(data)
  }

  const generateTotpSecretKey = useCallback(() => {
    setLoaded(false)
    MFAService.generateSecretKey(props.email)
      .then(response => {
        setQrCode(response.data.totpUri)
      })
      .catch(err => {
        console.log(err)
        setError("totpToken", { type: "custom", message: err.response.data.errorMessage })
      })
      .finally(() => {
        setLoaded(true)
      })
  },[props.email, setError])

  useEffect(() => {
    generateTotpSecretKey()
  }, [generateTotpSecretKey])

  return (
    <CModal show={props.modal} closeOnBackdrop={false}>
      <div className="atlas-header-mfa text-center">
        <img alt={'PTC Logo'} src="https://ptc-p-001.sitecorecontenthub.cloud/api/public/content/ff2edff8b42c48c98e20ad26ede84577?v=aabd3d85"/>
        <h1>{i18n.t('pages.users.registerMFA')}</h1><br/>
        {loaded ?
          <QRCode
            style={{ height: "150", maxWidth: "100%", width: "100%" }}
            value={qrCode}
            viewBox={`0 0 256 256`}
          />
          : <Loading/>}
        <div className="mfa-help-text mt-4">
          <p>Scan the QR Code below using your preferred authenticator app and then enter the provided one-time code below<br/></p>
        </div>
      </div>
      <CModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CFormGroup>
            <input
              type="text"
              className="form-control"
              id="totpToken"
              placeholder="Enter your one-time code"
              {...register('totpToken', {
                required: 'Authentication Code is required',
                pattern:{
                  value: /^(0|[1-9]\d*)(\.\d+)?$/,
                  message: 'Please enter a number',
                },
              })}
            />
            {errors?.totpToken?.message && (
              <span className="invalid-feedback">{errors.totpToken.message}</span>
            )}
            {props?.errorMessage && (
              <span className="invalid-feedback">{props.errorMessage}</span>
            )}
          </CFormGroup>
          <CButton disabled={props.submitLoading} type="submit" size="md" color="success">
            { !props.submitLoading && i18n.t('global.continue') }
            { props.submitLoading &&
              <>
                { props.submitLoading && i18n.t('global.loading') }
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
              </>
            }
          </CButton>
        </form>
      </CModalBody>
    </CModal>
  )
}

export default MultiFactorRegistration
